import { ajaxFunc } from '../tools';
const shoppingCart = {
  /****有关购物车模块的接口****/
  //获取购物车信息
  cart_list: ajaxFunc('/cart/cart_list', 'get'),

  //获取推荐商品信息
  get_recommended_goods_list: ajaxFunc('/goods/get_recommended_goods_list', 'get'),

  //商品删除
  drop_cart_goods: ajaxFunc('/cart/drop_cart_goods', 'post'),


  //失效商品晴空
  clear_invalid_goods: ajaxFunc('/cart/clear_invalid_goods', 'post'),


  //换购品删除
  update_cart_activity_give: ajaxFunc('/cart/update_cart_activity_give', 'post'),

  //更新商品数量
  change_cart_quantity: ajaxFunc('/cart/change_cart_quantity', 'post'),

  //查看换购满赠商品列表
  get_gift_list :ajaxFunc('/order/get_gift_list','get'),

  // 获取商品活动规格
  getActivityGoodsPriceInfo :ajaxFunc('/activity/getActivityGoodsPriceInfo','get'),

  addQuBuyGoods :ajaxFunc('/activity/addQuBuyGoods','get'),

  //確認訂單頁
  purchaseImmediately :ajaxFunc('/buyNow/purchaseImmediately','post'),

  // 选择优惠券后返回改笔订单的 商品总价，优惠金额，会员折扣，实付款金额
  useCoupons :ajaxFunc('/user/useCoupons','post')
};

export default shoppingCart;



// WEBPACK FOOTER //
// ./src/request/api/shoppingCart.js